import { h, Component } from "preact";
import plusIconEnabled from "../../assets/images/plus_increment_enabled.svg";
import plusIconDisabled from "../../assets/images/plus_increment_disabled.svg";
import minusIconDisabled from "../../assets/images/minus_decrement_disabled.svg";
import minusIconEnabled from "../../assets/images/minus_decrement_enabled.svg";
import { css } from "emotion";

class NumberIncrementorField extends Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }
  changeValue = number => {
    const { input } = this.props;
    input.onChange(number);
  };
  render() {
    const { input, disabled, max, label } = this.props;
    const { value } = input;
    const minusDisabled = value === 0 || disabled;
    const plusDisabled = value === max || disabled;
    const minusStyle = css({
      flex: 1,
      background: `url(${
        minusDisabled ? minusIconDisabled : minusIconEnabled
      }) no-repeat`,
      maxWidth: 22,
      maxHeight: 22,
      marginLeft: label ? 8 : 0
    });
    const plusStyle = css({
      flex: 1,
      background: `url(${
        plusDisabled ? plusIconDisabled : plusIconEnabled
      }) no-repeat`,
      maxWidth: 22,
      maxHeight: 22
    });
    const numberStyle = css({
      flex: 2,
      marginRight: 16,
      marginLeft: 16,
      textAlign: "center"
    });
    const incrementerStyle = css({
      display: "flex",
      flexDirection: "row",
      width: label ? 168 : 100
    });
    return (
      <div className={incrementerStyle}>
        {label ? (
          <label for={input.name} class="form-label">
            {label}
          </label>
        ) : (
          ""
        )}
        <button
          data-cy={`${input.name}-minus`}
          disabled={minusDisabled || disabled}
          className={minusStyle}
          type="button"
          onClick={() => this.changeValue(value - 1)}
        />
        <h4 className={numberStyle}>{value}</h4>
        <button
          data-cy={`${input.name}-plus`}
          disabled={plusDisabled || disabled}
          className={plusStyle}
          type="button"
          onClick={() => this.changeValue(value + 1)}
        />
      </div>
    );
  }
}

export default NumberIncrementorField;



// WEBPACK FOOTER //
// ./components/fields/NumberIncrementorField.js